(function (doc) {
  function placePopups() {
    doc.querySelectorAll('[data-fabric-benefit]').forEach(function (content) {
      var popup = content.closest('.benefits-Popover');
      if (!popup || popup.dataset.fabricBenefitReady) return;
      popup.dataset.fabricBenefitReady = 'true';
      popup.classList.add('benefits-Popover--fabric-benefit');
      var section = popup.closest('[id^="shopify-section-"]');
      var image = content.querySelector('[data-fabric-benefit-src]');
      function loadImage() {
        if (popup.getAttribute('aria-hidden') !== 'false' || !image || image.getAttribute('src')) return;
        image.addEventListener('error', function () { image.hidden = true; }, {once: true});
        image.src = image.dataset.fabricBenefitSrc;
      }
      var observer = new MutationObserver(loadImage);
      observer.observe(popup, {attributes: true, attributeFilter: ['aria-hidden']});
      popup.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || popup.getAttribute('aria-hidden') !== 'false') return;
        var controls = Array.from(popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function (node) {
          return !node.hidden && node.getAttribute('aria-hidden') !== 'true';
        });
        if (!controls.length) return;
        var first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (doc.activeElement === first || doc.activeElement === popup)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (doc.activeElement === last || doc.activeElement === popup)) {
          event.preventDefault(); first.focus();
        }
      });
      if (section) section.addEventListener('shopify:section:unload', function () {
        if (popup.getAttribute('aria-hidden') === 'false') popup.click();
        observer.disconnect();
        popup.remove();
      }, {once: true});
      doc.body.appendChild(popup);
      loadImage();
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', placePopups, {once: true});
  else placePopups();
})(document);
